import { ArrowLeft, ArrowRight, FileQuestion, RefreshCw, TriangleAlert } from 'lucide-react';
import { Logo } from '@/components/brand';
import { Button } from './button';
import { Panel } from './system';

/** Shared recovery screen, including when the dashboard shell cannot render. */
export function ErrorPage({
  missing = false,
  homeHref = '/',
  homeLabel = 'Go to overview',
}: {
  missing?: boolean;
  homeHref?: string;
  homeLabel?: string;
}) {
  const Icon = missing ? FileQuestion : TriangleAlert;
  const goBack = () => {
    if (window.history.state?.idx > 0) window.history.back();
    else window.location.assign(homeHref);
  };
  return (
    <main id="main-content" tabIndex={-1} className="error-page">
      <div className="error-page-content">
        <a className="error-page-brand" href={homeHref} aria-label="CallSync home">
          <Logo />
        </a>
        <Panel className="error-page-panel">
          <div className="error-page-message">
            <div className="error-page-context">
              <span className="error-page-icon">
                <Icon size={22} aria-hidden="true" />
              </span>
              <span>{missing ? '404 · Page not found' : 'Page unavailable'}</span>
            </div>
            <h1>{missing ? 'This page isn’t here' : 'Let’s try that again'}</h1>
            <p>
              {missing
                ? 'The link may have changed, or the address has a typo.'
                : 'Something interrupted this page. Reload it to try again.'}
            </p>
            {missing && (
              <div className="error-page-path">
                <span>Requested page</span>
                <code>{window.location.pathname}</code>
              </div>
            )}
            <div className="error-page-actions">
              {missing ? (
                <Button asChild>
                  <a href={homeHref}>
                    {homeLabel}
                    <ArrowRight />
                  </a>
                </Button>
              ) : (
                <Button onClick={() => window.location.reload()}>
                  <RefreshCw />
                  Reload page
                </Button>
              )}
              <Button variant="secondary" onClick={goBack}>
                <ArrowLeft />
                Go back
              </Button>
            </div>
            {!missing && (
              <a className="error-page-home" href={homeHref}>
                {homeLabel}
                <ArrowRight size={14} />
              </a>
            )}
          </div>
          <div className="error-page-support">
            <span>Need a hand?</span>
            <a href="/help">
              Help &amp; support
              <ArrowRight size={14} />
            </a>
          </div>
        </Panel>
      </div>
    </main>
  );
}
